import { useState } from 'react';
import { TYPE_BUTTONS } from '../../../../constans';
import PenaltyPopUpBase from './Base';
import { Button } from '../../../Basic/Buttons';

const PenaltyPopUp = ({ order = {}, checkup = {}, disabled = false, onChangeProduct = () => { }, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <Button type={TYPE_BUTTONS.RED} disabled={disabled} onClick={() => setIsOpen(true)}>
        Перенести в штраф
      </Button>

      {isOpen && (
        <PenaltyPopUpBase
          order={order}
          checkup={checkup}
          close={() => setIsOpen(false)}
          onClickOk={(data) => {
            onChangeProduct(data);
            setIsOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default PenaltyPopUp;
